import {get} from 'lodash';
import {User} from '@deviceinsight/ng-ui-api-client';
import {BLACKLISTED_TENANT_IDS} from './consts';
import type {JobVariant} from './types';
import './types';
export const getBlacklistedTenantIds = () => {
	return window.runtimeEnv[BLACKLISTED_TENANT_IDS] || import.meta.env[BLACKLISTED_TENANT_IDS];
};
export const getBundleAndVersion = (variant: JobVariant | null | undefined) => {
	return variant && variant.bundle && variant.version
		? {
				bundleId: variant.bundle.value,
				bundleVersionId: variant.version.value
		  }
		: undefined;
};
export const extractEmail = (user: User | null | undefined) => {
	if (user) {
		return get(user, 'principals.EMAIL[0].name');
	}
};
